module.exports = __webpack_public_path__ + "static/media/start_scene.b05a88df.png";